import React from "react";
import { BackgroundVariant, Section } from "../Section";
import { ResourcesCarousel } from ".";
import { ResourceCardProps, OverrideSlideProps } from "../ResourceCard";
import { Wrapper } from "../Wrapper";
import { isBrowser } from "../utils";

type ResourcesRowProps = {
  data: ResourceCardProps[];
  overrideEndSlides?: OverrideSlideProps[];
  sectionTitle: string;
  sectionSubtitle: string;
  backgroundVariant?: BackgroundVariant;
  paddingTopOverride?: string;
  isDotNavVisible?: boolean;
  slug?: string | string[];
  isImpactCards?:boolean;
};

export const ResourcesRow = ({
  data,
  overrideEndSlides,
  sectionTitle,
  sectionSubtitle,
  backgroundVariant,
  paddingTopOverride,
  isDotNavVisible,
  slug,
  isImpactCards
}: ResourcesRowProps) => {
  return (
    <Section.Outer
      backgroundVariant={backgroundVariant}
      paddingTopOverride={paddingTopOverride}
      isImpactCards={isImpactCards}
    >
      <Section.Heading title={sectionTitle} subtitle={sectionSubtitle} />
      {isBrowser() && (
        <Wrapper isExtraLarge>
          <ResourcesCarousel
            data={data}
            overrideEndSlides={overrideEndSlides}
            hasLightStyles={backgroundVariant === BackgroundVariant.GREY}
            isDotNavVisible={isDotNavVisible}
            slug={slug}
          />
        </Wrapper>
      )}
    </Section.Outer>
  );
};
